import { useNavigate } from "react-router";
import { Stepper } from "@/components/gb/stepper";
import { SETUP_STEPS, STEP, WizardColumn, WizardHeader } from "./wizard";
import { StepBasics } from "./step-basics";

/**
 * `/projects/new` — step 1 of setup, before a project exists.
 *
 * Its own route because there is genuinely no project id yet, so it cannot sit
 * under `/projects/:projectId` where everything else lives. That also gives the
 * picker's "New project" button something to link to, which a wizard reached
 * only by falling through a redirect would not have.
 *
 * `StepBasics` already branches on a null project to decide between create and
 * update, so it needs no change — only somewhere to go afterwards.
 */
export function NewProjectScreen() {
  const navigate = useNavigate();

  return (
    <WizardColumn>
      <WizardHeader />
      <Stepper
        steps={SETUP_STEPS}
        current={1}
        // Nothing is reachable yet: the project does not exist, so no later
        // step has anything to show.
        furthest={1}
        onSelect={() => {}}
        className="mb-[9px]"
      />
      <div className="mb-[18px] font-display text-[0.8rem] font-bold uppercase tracking-[0.06em] text-ink">
        Step 1 of {SETUP_STEPS.length} · {SETUP_STEPS[0]?.label}
      </div>
      <StepBasics
        project={null}
        // Always setup: there is no project yet, so there is nothing live to
        // edit. This route is the one place `mode` is not derived from a row.
        mode="setup"
        // The only call that reaches this is Cancel. On a successful create
        // `StepBasics` takes the `onCreated` path instead, because only that
        // knows the new project's id — and there is no project to go "back" to
        // from here, so every exit lands on the picker.
        goTo={() => void navigate("/")}
        onCreated={(project) => void navigate(`/projects/${project.id}/setup/${STEP.milestones}`)}
      />
    </WizardColumn>
  );
}
